module.exports = __webpack_public_path__ + "img/ku_logo.59c5fa1b.jpeg";